import React, { memo, useRef, useState, useEffect } from 'react';
import classes from './override.module.scss';
import { CircularProgress } from '@material-ui/core';

type Props = {
	button_display?: string;
	return_url?: string;
};

export const ErrorTemplate = memo((props: Props) => {
	const { button_display, return_url } = props;
	const [returnTransitioning, setReturnTransitioning] = useState(false);
	const returnTop = () => {
		setReturnTransitioning(true);
		const url = return_url ? return_url : '/';
		window.location.href = url;
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenID ただいまの操作はお受けできませんでした';
	}, []);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-txt-box">
						<div className={classes.notFoundTitle}>ただいまの操作はお受けできませんでした。</div>
						<p>しばらくしてからもう一度お試しください。</p>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							{returnTransitioning ? (
								<CircularProgress />
							) : (
								<button onClick={returnTop}>{button_display ? button_display : `GakkenIDページTOPへ戻る`}</button>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
});
